import {http} from "@/util/http";

export const save = async (name, token, duration, data) => {
  http.defaults.headers.common['x-access-token'] = token;
  return http.post(`user/trackEvent`, {
    eventName: 'exerciseDone',
    options: {
      exerciseId: name,
      duration,
      data
    }
  });
}
